var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00001 3.33333C2.73334 3.33333 3.33334 2.73333 3.33334 2C3.33334 1.26667 2.73334 0.666668 2.00001 0.666668C1.26667 0.666668 0.666672 1.26667 0.666672 2C0.666672 2.73333 1.26667 3.33333 2.00001 3.33333ZM2.00001 4.66667C1.26667 4.66667 0.666672 5.26667 0.666672 6C0.666672 6.73334 1.26667 7.33333 2.00001 7.33333C2.73334 7.33333 3.33334 6.73334 3.33334 6C3.33334 5.26667 2.73334 4.66667 2.00001 4.66667ZM2.00001 8.66667C1.26667 8.66667 0.666672 9.26667 0.666672 10C0.666672 10.7333 1.26667 11.3333 2.00001 11.3333C2.73334 11.3333 3.33334 10.7333 3.33334 10C3.33334 9.26667 2.73334 8.66667 2.00001 8.66667Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.01f0d9f3.svg";
export { ForwardRef as ReactComponent };